export function parseComponentStyle(source) {
    const { textFontSize, textFontWeight, textMarginHorizontal, textMarginVertical, textColor, iconColor, iconHeight, iconWidth, iconName, iconMarginHorizontal, iconMarginVertical, iconMarginRight, hoverBorderColor, hoverBackgroundColor, activeBorderColor, activeBackgroundColor, ...container } = source;
    return {
        container,
        hoverContainer: {
            borderColor: hoverBorderColor,
            backgroundColor: hoverBackgroundColor,
        },
        activeContainer: {
            borderColor: activeBorderColor,
            backgroundColor: activeBackgroundColor,
        },
        textStyle: {
            color: textColor,
            fontSize: textFontSize,
            fontWeight: textFontWeight,
            marginHorizontal: textMarginHorizontal,
            marginBottom: textMarginVertical,
        },
        iconStyle: {
            color: iconColor,
            height: iconHeight,
            width: iconWidth,
            marginRight: iconMarginRight,
        },
        iconName,
    };
}
//# sourceMappingURL=util.js.map